<template lang="pug">
  v-dialog(:value="true", :persistent="true", :max-width="500", v-if="!loading")
    v-card
      v-card-title
        h3.headline {{$t("Login")}}
      v-form(ref="loginForm", @submit='handleSubmit')
        v-card-text
          v-text-field(:label="$t('E-mail')", v-model="credentials.email", :rules="validation.email", required)
          v-text-field(:label="$t('Contraseña')", type="password", v-model="credentials.password", :rules="validation.password", required)
        v-card-actions
          v-btn(text, color="blue", type="submit") {{$t('Acceder')}}
  v-container(fluid fill-height v-else)
    v-layout(flex align-center justify-center)
      v-progress-circular(indeterminate, color="primary", :size="128", :width="2")
</template>

<script>
  module.exports = {
    data() {
      return {
        loading: false,
        credentials: {
          email: '',
          password: '',
        },
        validation: {
          email: [
            v => !!v || 'E-mail is required',
          ],
          password: [
            v => !!v || 'Password is required',
          ],
        },
      };
    },
    created() {
      if (localStorage.token) {
        this.loading = true;
        this.authenticate(localStorage.token);
      }
    },
    methods: {
      handleSubmit() {
        if (this.$refs.loginForm.validate()) {
          api.post('/login', this.credentials).then((res) => {
            this.loading = true;
            const token = res.data.token;
            this.authenticate(token);
          }).catch(() => {
            this.error = 'Usuario o contraseña erróneos';
            this.loading = false;
          });
        }
      },
      authenticate(token) {
        api.get('/users/me', {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }).then((res) => {
          localStorage.token = token;
          api.defaults.headers.authorization = `Bearer ${token}`;
          store.commit('login', token, res.data);
          this.$router.push(store.state.redirectTo);
        }).catch(() => {
          if (localStorage.token) {
            localStorage.token = null;
            api.defaults.headers.authorization = null;
            this.error = 'La sesión ha caducado';
          } else {
            this.error = 'Ha ocurrido un problema al iniciar sesión';
          }
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue